import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventValue, AnalyticEventCategory, AnalyticEventType} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {createDivIn, createParagraphIn} from '../../../../shared/scripts/ui_utils/DomUtils'
import {ViewPopup} from '../../../../shared/scripts/ui_popup/ViewPopup'
import {TranslationObject} from '@colonist/i18n'
import {ViewPopupOptions} from '../../../../shared/scripts/ui_popup/ViewPopupOptions'
import {navigateToPage} from '../../../../shared/scripts/ui_utils/ClientUtils.ts'

export interface SoftPopupOptions {
    continuationText: TranslationObject
    continuationAction: () => void
}

export class ViewPopupDisableAdblockMain extends ViewPopup {
    constructor(title: TranslationObject, body: TranslationObject, canCancel: boolean, completionAction: () => void, softPopupOptions?: SoftPopupOptions) {
        const disableAdBlockAction = () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.AdblockPopupDisableAction,
            }
            void CA.sendAnalyticEvent(eventData)
            window.history.pushState('', document.title, window.location.pathname + window.location.search)
            completionAction()
            navigateToPage('/disable-ad-block', true)
        }
        const becomeMemberAction = () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.AdblockPopupBecomeMemberAction,
            }
            void CA.sendAnalyticEvent(eventData)
            window.history.pushState('', document.title, window.location.pathname + window.location.search)
            completionAction()
            navigateToPage('/store#membership', true)
        }

        const options: ViewPopupOptions = {
            showCheckButton: true,
            checkButtonCustomContent: {key: 'strings:popups.uhOh.checkButton'},
            showXButton: true,
            xButtonCustomContent: {key: 'strings:popups.uhOh.xButton'},
        }
        super(title, {key: 'strings:colonistCommon.utils.emptyString'}, becomeMemberAction, disableAdBlockAction, canCancel, options)

        createParagraphIn(this.body, body, '')
        this.xButton.className = 'popup_adblock_cta_btn'
        this.checkButton.className = 'popup_adblock_cta_btn popup_adblock_cta_btn_main'
        if(softPopupOptions != undefined) {
            this.createSoftPopupContinuationLink(softPopupOptions)
        }

        this.removeAction = () => {
            window.history.pushState('', document.title, window.location.pathname + window.location.search)
        }

        this.show()
    }

    private createSoftPopupContinuationLink(softPopupOptions: SoftPopupOptions): void {
        const footerDiv = createDivIn(this.contentContainer, 'popup-adblock-bottom')
        const continueAdblockLinkElement = createParagraphIn(footerDiv, softPopupOptions.continuationText, 'continue_adblock_link_text')
        if(continueAdblockLinkElement == null) return
        continueAdblockLinkElement.onclick = () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.AdblockPopupContinueAction,
            }
            void CA.sendAnalyticEvent(eventData)
            softPopupOptions.continuationAction()
            this.removePopup()
        }
    }
}
